/**
 * NNDonutChart — shared donut chart using Apache ECharts.
 * Tree-shaken to only PieChart + Tooltip + Canvas renderer.
 * Mirrors NNLineChart.jsx pattern.
 *
 * Props:
 *   value  — current numeric value (the filled arc)
 *   total  — maximum value (default 100)
 *   color  — hex/rgb fill color for the filled arc
 *   size   — pixel width and height of the chart (default 80)
 */
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { TooltipComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import ReactECharts from 'echarts-for-react';

echarts.use([PieChart, TooltipComponent, CanvasRenderer]);

export default function NNDonutChart({ value = 0, total = 100, color = '#0891B2', size = 80 }) {
  const remaining = Math.max(0, total - value);
  const pct = total > 0 ? Math.round((value / total) * 100) : 0;

  const option = {
    animation: true,
    animationDuration: 600,
    animationEasing: 'cubicOut',
    tooltip: { show: false },
    series: [
      {
        type: 'pie',
        radius: ['62%', '88%'],
        silent: true,
        data: [
          { value, itemStyle: { color } },
          { value: remaining, itemStyle: { color: '#E2E8F0' } },
        ],
        label: { show: false },
        emphasis: { scale: false },
      },
    ],
  };

  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <ReactECharts
        echarts={echarts}
        option={option}
        style={{ width: size, height: size }}
        opts={{ renderer: 'canvas' }}
      />
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: Math.round(size * 0.2),
          fontWeight: 700,
          color: 'var(--navy-deep)',
          letterSpacing: '-0.5px',
          pointerEvents: 'none',
          fontFamily: 'var(--font-body)',
        }}
      >
        {pct}%
      </div>
    </div>
  );
}
